$(function () {
  if (!customElements.get('about-brand-positioning')) {
    customElements.define(
      'about-brand-positioning',
      class aboutBrandPositioning extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          gsap.registerPlugin(ScrollTrigger);
          const root = $(this); // 保存当前实例对应的 DOM 元素
          const $main = root.find('.main');
          const $item1 = root.find('.item1');
          const $item2 = root.find('.item2');
          const $item3 = root.find('.item3');
          const $item4 = root.find('.item4');
          const $item5 = root.find('.item5');
          const $item6 = root.find('.item6');

          gsap
            .timeline({
              scrollTrigger: {
                pin: true,
                pinSpacing: true,
                anticipatePin: 1,
                scrub: true,
                trigger: $main[0], // 使用 jQuery 获取的元素需要使用原生 DOM 节点
                start: '0 0',
                end: $main.height() * 2.5,
                scrub: 1,
              },
            })
            .to($item1[0], { y: -500, opacity: 0 }, 0)
            .to($item2[0], { opacity: 0, scale: 20 }, 0)
            .to($item6[0], { y: 500, opacity: 0 }, 0)
            .to($item3[0], { y: 500, opacity: 0 }, 0)
            .to($item4[0], { opacity: 0 }, 0)
            .fromTo($item5[0], { y: 500, opacity: 0 }, { y: 0, opacity: 1, duration: 0.3, zIndex: 999 }, '>0.2');
        }
      }
    );
  }
});
